var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitadosText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 353.1 17.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_3-18);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19{stroke-width:0px;}.cls-2{fill:url(#Degradado_sin_nombre_3-12);}.cls-3{fill:url(#Degradado_sin_nombre_3);}.cls-4{fill:url(#Degradado_sin_nombre_3-17);}.cls-5{fill:url(#Degradado_sin_nombre_3-14);}.cls-6{fill:url(#Degradado_sin_nombre_3-15);}.cls-7{fill:url(#Degradado_sin_nombre_3-2);}.cls-8{fill:url(#Degradado_sin_nombre_3-9);}.cls-9{fill:url(#Degradado_sin_nombre_3-5);}.cls-10{fill:url(#Degradado_sin_nombre_3-16);}.cls-11{fill:url(#Degradado_sin_nombre_3-11);}.cls-12{fill:url(#Degradado_sin_nombre_3-8);}.cls-13{fill:url(#Degradado_sin_nombre_3-7);}.cls-14{fill:url(#Degradado_sin_nombre_3-10);}.cls-15{fill:url(#Degradado_sin_nombre_3-19);}.cls-16{fill:url(#Degradado_sin_nombre_3-6);}.cls-17{fill:url(#Degradado_sin_nombre_3-13);}.cls-18{fill:url(#Degradado_sin_nombre_3-4);}.cls-19{fill:url(#Degradado_sin_nombre_3-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 7.02,
    y1: 22.87,
    x2: 7.02,
    y2: 2.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#664206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f2e096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f5e8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c4a96c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2e096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-2",
    x1: 24.84,
    y1: 22.87,
    x2: 24.84,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-3",
    x1: 43.85,
    y1: 22.87,
    x2: 43.85,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-4",
    x1: 63.97,
    y1: 22.87,
    x2: 63.97,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-5",
    x1: 83.52,
    y1: 22.87,
    x2: 83.52,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-6",
    x1: 101.84,
    y1: 22.87,
    x2: 101.84,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-7",
    x1: 122.79,
    y1: 22.87,
    x2: 122.79,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-8",
    x1: 143.74,
    y1: 22.87,
    x2: 143.74,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-9",
    x1: 171.52,
    y1: 22.87,
    x2: 171.52,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-10",
    x1: 189.74,
    y1: 22.87,
    x2: 189.74,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-11",
    x1: 210.22,
    y1: 22.87,
    x2: 210.22,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-12",
    x1: 224.62,
    y1: 22.87,
    x2: 224.62,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-13",
    x1: 244.17,
    y1: 22.87,
    x2: 244.17,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-14",
    x1: 258.28,
    y1: 22.87,
    x2: 258.28,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-15",
    x1: 271.2,
    y1: 22.87,
    x2: 271.2,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-16",
    x1: 287.54,
    y1: 22.87,
    x2: 287.54,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-17",
    x1: 307.55,
    y1: 22.87,
    x2: 307.55,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-18",
    x1: 327.41,
    y1: 22.87,
    x2: 327.41,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-19",
    x1: 345.84,
    y1: 22.87,
    x2: 345.84,
    y2: 2.51,
    xlinkHref: "#Degradado_sin_nombre_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,.33h7.13c4.21,0,6.92,2.16,6.92,5.85v.05c0,3.92-3.02,5.99-7.15,5.99h-2.28v4.75H0V.33Zm6.8,8.27c1.64,0,2.64-.86,2.64-2.16v-.05c0-1.43-1-2.19-2.66-2.19h-2.16v4.4h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m17.18.33h7.87c2.54,0,4.3.67,5.42,1.81.97.95,1.47,2.23,1.47,3.87v.05c0,2.54-1.35,4.23-3.42,5.11l3.97,5.8h-5.32l-3.35-5.04h-2.02v5.04h-4.61V.33Zm7.65,7.99c1.57,0,2.47-.76,2.47-1.97v-.05c0-1.31-.95-1.97-2.5-1.97h-3.02v3.99h3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m34.89,8.7v-.05c0-4.78,3.85-8.65,8.98-8.65s8.94,3.83,8.94,8.6v.05c0,4.78-3.85,8.65-8.98,8.65s-8.94-3.83-8.94-8.6Zm13.21,0v-.05c0-2.4-1.74-4.49-4.28-4.49s-4.21,2.04-4.21,4.44v.05c0,2.4,1.73,4.49,4.25,4.49s4.23-2.04,4.23-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m55.83,8.7v-.05c0-4.85,3.8-8.65,8.96-8.65,2.92,0,4.99.9,6.75,2.42l-2.71,3.26c-1.19-1-2.38-1.57-4.02-1.57-2.4,0-4.25,2.02-4.25,4.56v.05c0,2.69,1.88,4.61,4.52,4.61,1.12,0,1.97-.24,2.66-.69v-2.02h-3.28v-3.37h7.65v7.49c-1.76,1.45-4.21,2.57-7.23,2.57-5.18,0-9.06-3.57-9.06-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m75.87.33h7.87c2.54,0,4.3.67,5.42,1.81.97.95,1.47,2.23,1.47,3.87v.05c0,2.54-1.35,4.23-3.42,5.11l3.97,5.8h-5.32l-3.35-5.04h-2.02v5.04h-4.61V.33Zm7.65,7.99c1.57,0,2.47-.76,2.47-1.97v-.05c0-1.31-.95-1.97-2.5-1.97h-3.02v3.99h3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m99.61.21h4.44l7.08,16.76h-4.94l-1.21-2.97h-6.42l-1.19,2.97h-4.85L99.61.21Zm4.04,10.2l-1.85-4.73-1.88,4.73h3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m113.95.33h4.87l3.97,6.44,3.97-6.44h4.87v16.64h-4.59V7.42l-4.25,6.51h-.1l-4.23-6.46v9.51h-4.52V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m141.52.21h4.44l7.08,16.76h-4.94l-1.21-2.97h-6.42l-1.19,2.97h-4.85L141.52.21Zm4.04,10.2l-1.85-4.73-1.88,4.73h3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m163.62.33h6.42c5.94,0,9.39,3.42,9.39,8.22v.05c0,4.8-3.49,8.37-9.48,8.37h-6.32V.33Zm6.49,12.55c2.76,0,4.59-1.52,4.59-4.21v-.05c0-2.66-1.83-4.21-4.59-4.21h-1.88v8.46h1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m182.99.33h13.38v3.92h-8.82v2.52h7.99v3.64h-7.99v2.64h8.94v3.92h-13.5V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m207.9.33h4.63v16.64h-4.63V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m216.77.33h4.3l6.84,8.79V.33h4.56v16.64h-4.04l-7.11-9.13v9.13h-4.56V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m235.28.33h5.16l3.78,10.53,3.78-10.53h5.06l-6.75,16.76h-4.28L235.28.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m255.96.33h4.63v16.64h-4.63V.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m268.89,4.37h-4.99V.33h14.59v4.04h-4.99v12.6h-4.61V4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m285.31.21h4.44l7.08,16.76h-4.94l-1.21-2.97h-6.42l-1.19,2.97h-4.85L285.31.21Zm4.04,10.2l-1.85-4.73-1.88,4.73h3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m299.65.33h6.42c5.94,0,9.39,3.42,9.39,8.22v.05c0,4.8-3.49,8.37-9.48,8.37h-6.32V.33Zm6.49,12.55c2.76,0,4.59-1.52,4.59-4.21v-.05c0-2.66-1.83-4.21-4.59-4.21h-1.88v8.46h1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.45,8.7v-.05c0-4.78,3.85-8.65,8.98-8.65s8.94,3.83,8.94,8.6v.05c0,4.78-3.85,8.65-8.98,8.65s-8.94-3.83-8.94-8.6Zm13.21,0v-.05c0-2.4-1.73-4.49-4.28-4.49s-4.21,2.04-4.21,4.44v.05c0,2.4,1.73,4.49,4.25,4.49s4.23-2.04,4.23-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m338.58,14.5l2.57-3.07c1.64,1.31,3.47,2,5.4,2,1.24,0,1.9-.43,1.9-1.14v-.05c0-.69-.55-1.07-2.8-1.59-3.54-.81-6.27-1.81-6.27-5.23v-.05c0-3.09,2.45-5.32,6.44-5.32,2.83,0,5.04.76,6.85,2.21l-2.31,3.26c-1.52-1.07-3.18-1.64-4.66-1.64-1.12,0-1.66.48-1.66,1.07v.05c0,.76.57,1.09,2.88,1.62,3.83.83,6.2,2.07,6.2,5.18v.05c0,3.4-2.69,5.42-6.73,5.42-2.95,0-5.75-.93-7.8-2.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitadosText);
export default __webpack_public_path__ + "static/media/invitados-text.d6e57a172876ef74ec42b1cc5e7916bc.svg";
export { ForwardRef as ReactComponent };